import { ReactElement } from 'react'

import * as S from './DashboardCard.styles'

interface DashboardCardProps {
  icon: ReactElement
  label: string
  value: string
  title?: string
  label2?: string
  value2?: string
  label3?: string
  value3?: string
}

export const DashboardCard = ({
  icon,
  label,
  value,
  title,
  label2,
  value2,
  label3,
  value3,
}: DashboardCardProps) => {
  return (
    <S.Card>
      <S.CardHeader>
        <S.IconWrapper>{icon}</S.IconWrapper>
        {title ? <S.Title>{title}</S.Title> : null}
      </S.CardHeader>
      <S.ValuesRow>
        <S.CardContent>
          <S.Caption>{label}</S.Caption>
          <S.Total>{value}</S.Total>
        </S.CardContent>
        {value2 && label2 ? (
          <S.CardContent>
            <S.Caption>{label2}</S.Caption>
            <S.Total>{value2}</S.Total>
          </S.CardContent>
        ) : null}
        {value3 && label3 ? (
          <S.CardContent>
            <S.Caption>{label3}</S.Caption>
            <S.Total>{value3}</S.Total>
          </S.CardContent>
        ) : null}
      </S.ValuesRow>
    </S.Card>
  )
}
